/**
 * Development-only console helpers.
 * No-op in production builds to avoid leaking PII, tokens, or API URLs.
 */
const isDev = process.env.NODE_ENV === 'development';

function noop() {}

export const devLog = {
  log: isDev ? (...args) => console.log(...args) : noop,
  warn: isDev ? (...args) => console.warn(...args) : noop,
  error: isDev ? (...args) => console.error(...args) : noop,
};
